import { useState } from "react";
import { AlertTriangle } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Field, PageHeader } from "@/components/shared/Common";
import { useAuth } from "@/context/AuthContext";
import { api, errMsg } from "@/lib/api";
import { SCOPE_LABELS } from "@/lib/format";

const ChangePassword = ({ onDone }) => {
  const [f, setF] = useState({ current_password: "", new_password: "", confirm: "" });
  const submit = async (e) => {
    e.preventDefault();
    if (f.new_password !== f.confirm) return toast.error("Las contraseñas no coinciden");
    try {
      await api.post("/auth/change-password", { current_password: f.current_password, new_password: f.new_password });
      toast.success("Contraseña actualizada");
      setF({ current_password: "", new_password: "", confirm: "" });
      onDone();
    } catch (err) { toast.error(errMsg(err)); }
  };
  return (
    <form onSubmit={submit} className="syc-card p-6 space-y-4" data-testid="change-password-form">
      <h2 className="text-base md:text-lg font-bold">Cambiar contraseña</h2>
      <Field label="Contraseña actual"><Input data-testid="current-password-input" type="password" value={f.current_password} onChange={(e) => setF({ ...f, current_password: e.target.value })} required /></Field>
      <Field label="Nueva contraseña" hint="Mín. 10 caracteres, letras y números. Se cerrarán sus otras sesiones."><Input data-testid="new-password-input" type="password" value={f.new_password} onChange={(e) => setF({ ...f, new_password: e.target.value })} required /></Field>
      <Field label="Confirmar nueva contraseña"><Input data-testid="confirm-password-input" type="password" value={f.confirm} onChange={(e) => setF({ ...f, confirm: e.target.value })} required /></Field>
      <Button data-testid="change-password-submit-btn" className="rounded-full">Actualizar contraseña</Button>
    </form>
  );
};

export default function MyAccount() {
  const { user, reload } = useAuth();
  return (
    <div data-testid="my-account-page">
      <PageHeader eyebrow="Mi cuenta" title={user.name} subtitle={user.email} />
      {user.must_change_password && (
        <div data-testid="must-change-password-alert" className="mb-6 flex items-start gap-3 rounded-xl border border-[#FFE100] bg-[#fffbe0] p-4 text-sm">
          <AlertTriangle className="text-[#c9a400] shrink-0" size={18} />
          <span>Su contraseña es temporal. Debe cambiarla para continuar usando SYC CONTROL.</span>
        </div>
      )}
      <div className="grid lg:grid-cols-2 gap-6">
        <ChangePassword onDone={reload} />
        <div className="syc-card p-6 space-y-5" data-testid="my-access-card">
          <h2 className="text-base md:text-lg font-bold">Mis accesos</h2>
          <div>
            <div className="text-xs font-semibold uppercase tracking-[0.12em] text-[#5b6656] mb-2">Roles</div>
            <div className="flex flex-wrap gap-2">{user.roles.length ? user.roles.map((r) => <span key={r.id} className="rounded-full bg-[#e9f7e1] px-3 py-1 text-xs font-semibold text-[#1c6e00]">{r.name}</span>) : <span className="text-sm text-[#5b6656]">Sin roles asignados</span>}</div>
          </div>
          <div>
            <div className="text-xs font-semibold uppercase tracking-[0.12em] text-[#5b6656] mb-2">Alcance</div>
            {Object.keys(SCOPE_LABELS).map((k) => (
              <div key={k} className="text-sm py-1"><b>{SCOPE_LABELS[k]}:</b> {user.scopes[k]?.includes("*") ? "Todos" : user.scopes[k]?.join(", ") || "Ninguno"}</div>
            ))}
          </div>
          <div className="text-xs text-[#5b6656]">{user.permissions.length} privilegios efectivos.</div>
        </div>
      </div>
    </div>
  );
}
